import {
  orgConstants,
  alertConstants,
  userConstants,
  dealjacketConstants,
} from "../constants";
import { orgService } from "../services";
import { alertActions } from "./alert.actions.js";
import { history } from "../helpers";

export const orgActions = {
  getList,
  setCurrentOrgId,
  createOrg,
  getOrgTypes,
  getIngestionStats,
  getScrapeInfo,
  getOcrInfo,
  getOrgDetail,
  getOrgUsers,
  getDocTypes,
  editOrg,
  resetOrgEdit,
  createDocType,
  editDocType,
  deleteDocType
};

function getList(user_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching orgs..."));
    dispatch(listRequest(user_id));

    orgService.getList(user_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error.message));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(user_id) {
    return { type: orgConstants.ORG_GETLIST_REQUEST, user_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: orgConstants.ORG_GETLIST_SUCCESS, list };
  }
  function failure(message) {
    return { type: orgConstants.ORG_GETLIST_FAILURE, message };
  }
}


function getOrgDetail(org_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching org..."));
    dispatch(detailRequest(org_id));

    orgService.getDetail(org_id).then(
      (org) => {
        dispatch(refreshToken(org.newToken));
        dispatch(clearAlert());
        dispatch(success(org));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error.message));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function detailRequest(user_id) {
    return { type: orgConstants.ORG_GET_ORG_DETAIL_REQUEST, user_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(org) {
    return { type: orgConstants.ORG_GET_ORG_DETAIL_SUCCESS, org };
  }
  function failure(message) {
    return { type: orgConstants.ORG_GET_ORG_DETAIL_FAILURE, message };
  }
}

function getOrgUsers(org_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching org..."));
    dispatch(listRequest(org_id));

    orgService.getOrgUsers(org_id).then(
      (users) => {
        dispatch(refreshToken(users.newToken));
        dispatch(clearAlert());
        dispatch(success(users));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error.message));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(org_id) {
    return { type: orgConstants.ORG_GET_ORG_USERS_REQUEST, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(users) {
    return { type: orgConstants.ORG_GET_ORG_USERS_SUCCESS, users };
  }
  function failure(message) {
    return { type: orgConstants.ORG_GET_ORG_USERS_FAILURE, message };
  }
}

function setCurrentOrgId(org_id) {
  /*
   * This will navigate the user to a new data view on same screen if needed
   */
  return (dispatch) => {
    dispatch({ type: orgConstants.ORG_SET_CURRENT_ORG_ID, org_id });
    dispatch({ type: dealjacketConstants.CLEAR_JACKETS });
    let path = history.location.pathname;
    if (path.match(/^\/org\/\d*\/.*$/)) {
      let newPath = path.replace(/(\/org\/\d*)/, "/org/" + org_id);
      if (newPath !== path) {
        history.push(newPath);
      }
    }
  };
}

function resetOrgEdit() {
  return (dispatch) => {
    dispatch({ type: orgConstants.ORG_EDIT_RESET })
  }
  
}

function getOrgTypes() {
  return (dispatch) => {
    dispatch(uploadAlert("fetching org types"));
    dispatch(getRequest);

    orgService.getOrgTypes().then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure);
        dispatch(alertActions.error("There was a problem fetching org types."));
      }
    );
  };

  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function getRequest() {
    return { type: orgConstants.ORG_ORGTYPES_REQUEST };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: orgConstants.ORG_ORGTYPES_SUCCESS, list };
  }
  function failure() {
    return { type: orgConstants.ORG_ORGTYPES_FAILURE };
  }
}

function createOrg(org) {
  return (dispatch) => {
    dispatch(uploadAlert("creating org"));
    dispatch(createRequest(org));

    orgService.createOrg(org).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response));
        dispatch(getList());
        history.push("/orgs", { message: "Org created!" });
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(org));
        dispatch(alertActions.error("Unable to create org: "+error));
      }
    );
  };

  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function createRequest(org) {
    return { type: orgConstants.ORG_CREATE_REQUEST, org };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(org) {
    return { type: orgConstants.ORG_CREATE_SUCCESS, org };
  }
  function failure(org) {
    return { type: orgConstants.ORG_CREATE_FAILURE, org };
  }
}

function editOrg(org) {
  return (dispatch) => {
    dispatch(uploadAlert("updating org"));
    dispatch(createRequest(org));

    orgService.editOrg(org).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response));
        dispatch(getList());
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(org));
        dispatch(alertActions.error("Couldn't edit the org: "+error));
      }
    );
  };

  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function createRequest(org) {
    return { type: orgConstants.ORG_EDIT_REQUEST, org };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(org) {
    return { type: orgConstants.ORG_EDIT_SUCCESS, org };
  }
  function failure(org) {
    return { type: orgConstants.ORG_EDIT_FAILURE, org };
  }
}


function getIngestionStats(org_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching ingestion stats..."));
    dispatch(listRequest(org_id));

    orgService.getIngestionStats(org_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(user_id) {
    return { type: orgConstants.ORG_INGESTION_STATS_REQUEST, user_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: orgConstants.ORG_INGESTION_STATS_SUCCESS, list };
  }
  function failure(message) {
    return { type: orgConstants.ORG_INGESTION_STATS_FAILURE, message };
  }
}

function getScrapeInfo(org_id) {
  return (dispatch) => {
    dispatch(scrapeInfoRequest(org_id));

    orgService.getScrapeInfo(org_id).then(
      (info) => {
        dispatch(refreshToken(info.newToken));
        dispatch(success(info));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function scrapeInfoRequest(org_id) {
    return { type: orgConstants.ORG_SCRAPE_INFO_REQUEST, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function success(info) {
    return { type: orgConstants.ORG_SCRAPE_INFO_SUCCESS, info };
  }
  function failure(message) {
    return { type: orgConstants.ORG_SCRAPE_INFO_FAILURE, message };
  }
}

function getOcrInfo(org_id) {
  return (dispatch) => {
    dispatch(ocrInfoRequest(org_id));

    orgService.getOcrInfo(org_id).then(
      (info) => {
        dispatch(refreshToken(info.newToken));
        dispatch(success(info));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function ocrInfoRequest(org_id) {
    return { type: orgConstants.ORG_OCR_INFO_REQUEST, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function success(info) {
    return { type: orgConstants.ORG_OCR_INFO_SUCCESS, info };
  }
  function failure(message) {
    return { type: orgConstants.ORG_OCR_INFO_FAILURE, message };
  }
}



function getDocTypes(org_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching doc types..."));
    dispatch(listRequest());

    orgService.getDocTypes(org_id).then(
      (doctypes) => {
        dispatch(refreshToken(doctypes.newToken));
        dispatch(clearAlert());
        dispatch(success(doctypes));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error.message));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(org_id) {
    return { type: orgConstants.ORG_GET_DOC_TYPES_REQUEST };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(doctypes) {
    return { type: orgConstants.ORG_GET_DOC_TYPES_SUCCESS, doctypes };
  }
  function failure(message) {
    return { type: orgConstants.ORG_GET_DOC_TYPES_FAILURE, message };
  }
}

function createDocType(docTypeRequest) {
  return (dispatch) => {
    dispatch(uploadAlert("creating doc type"));
    dispatch(createRequest(docTypeRequest));

    orgService.createDocType(docTypeRequest).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(docTypeRequest));
        dispatch(alertActions.error("Unable to create doc type: "+error));
      }
    );
  };

  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function createRequest(docTypeRequest) {
    return { type: orgConstants.ORG_CREATE_DOCTYPE_REQUEST, docTypeRequest };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(org) {
    return { type: orgConstants.ORG_CREATE_DOCTYPE_SUCCESS, docTypeRequest };
  }
  function failure(org) {
    return { type: orgConstants.ORG_CREATE_DOCTYPE_FAILURE, docTypeRequest };
  }
}

function editDocType(docTypeRequest) {
  return (dispatch) => {
    dispatch(uploadAlert("editing doc type"));
    dispatch(editRequest(docTypeRequest));

    orgService.editDocType(docTypeRequest).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response));
        dispatch(getDocTypes(docTypeRequest.org_id));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(docTypeRequest));
        dispatch(alertActions.error("Unable to edit doc type: "+error));
      }
    );
  };

  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function editRequest(docTypeRequest) {
    return { type: orgConstants.ORG_EDIT_DOCTYPE_REQUEST, docTypeRequest };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(org) {
    return { type: orgConstants.ORG_EDIT_DOCTYPE_SUCCESS, docTypeRequest };
  }
  function failure(org) {
    return { type: orgConstants.ORG_EDIT_DOCTYPE_FAILURE, docTypeRequest };
  }
}

function deleteDocType(docTypeRequest) {
  return (dispatch) => {
    dispatch(alertActions.spinner("deleteing document type..."));
    dispatch(deleteRequest(docTypeRequest));

    orgService.deleteDocType(docTypeRequest).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response));
        dispatch(getDocTypes(docTypeRequest.org_id));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(docTypeRequest));
        dispatch(alertActions.error("Unable to delete doc type: "+error));
      }
    );
  };

  function deleteRequest(docTypeRequest) {
    return { type: orgConstants.ORG_DELETE_DOCTYPE_REQUEST, docTypeRequest };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(org) {
    return { type: orgConstants.ORG_DELETE_DOCTYPE_SUCCESS, docTypeRequest };
  }
  function failure(org) {
    return { type: orgConstants.ORG_DELETE_DOCTYPE_FAILURE, docTypeRequest };
  }
}